<!-- eslint-disable max-len -->
<template>
  <div class="w-full">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-0">
      <form-item label='Phone Number'>
        <template v-slot>
          <Input
            v-model="phone_number"
            placeholder="Phone Number"
            :error="$v.phone_number.$dirty && !$v.phone_number.required"
          />
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.phone_number.$dirty && !$v.phone_number.required" text="Please fill your phone number." />
          </div>
        </template>
      </form-item>
      <form-item label='Local Conference'>
        <template v-slot>
          <Input
            v-model="missions"
            placeholder="Local Conference"
            :error="$v.missions.$dirty && !$v.missions.required"
          />
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.missions.$dirty && !$v.missions.required" text="Please fill your local conference." />
          </div>
        </template>
      </form-item>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-0">
      <form-item label='Church'>
        <template v-slot>
          <Input
            v-model="church"
            placeholder="Church"
            :error="$v.church.$dirty && !$v.church.required"
          />
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.church.$dirty && !$v.church.required" text="Please fill your church." />
          </div>
        </template>
      </form-item>
      <form-item label='Monetize Choice'>
        <template v-slot>
          <el-select v-model="monetize_choice" filterable placeholder="Select"
                     :class="$v.monetize_choice.$dirty && $v.monetize_choice.$anyError ? 'border-red-500' : ''" class="w-full">
            <el-option
              v-for="item in monetizeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.monetize_choice.$dirty && !$v.monetize_choice.required" text="Please choose a monetize option." />
          </div>
        </template>
      </form-item>
    </div>
    <form-item label='Links' info="Portfolio, social media, or demo links (URLs).">
      <template v-slot>
        <TextArea
          v-model="links"
          placeholder="Links"
          :error="$v.links.$dirty && !$v.links.required"
          rows="2"
        />
        <div class="flex flex-col pt-2">
          <text-error v-if="$v.links.$dirty && !$v.links.required" text="Please fill your links." />
        </div>
      </template>
    </form-item>
    <form-item label='Self Introduction'>
      <template v-slot>
        <TextArea
          v-model="self_introduction"
          placeholder="Tell us about yourself"
          :error="$v.self_introduction.$dirty && !$v.self_introduction.required"
          rows="4"
        />
        <div class="flex flex-col pt-2">
          <text-error v-if="$v.self_introduction.$dirty && !$v.self_introduction.required" text="Please fill your self introduction." />
        </div>
      </template>
    </form-item>
    <div class="px-4 py-4">
      <label class="flex items-start">
        <input type="checkbox" v-model="legal_accepted" class="mt-1 mr-2" />
        <span class="text-sm text-gray-700">
          I accept the <a href="https://musicverse.org/terms-and-conditions" target="_blank" rel="noopener noreferrer" class="underline">Terms and Conditions</a> and confirm the information provided is accurate.
        </span>
      </label>
      <div class="flex flex-col pt-2">
        <text-error v-if="$v.legal_accepted.$dirty && !$v.legal_accepted.checked" text="You must accept the Terms and Conditions." />
      </div>
    </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { FormItem, Input, TextArea, TextError } from '@/components/Layout/Form';

export default {
  name: 'FormArtistApplication',
  mixins: [validationMixin],
  data: () => ({
    monetizeOptions: [
      { value: 'free', label: 'Free' },
      { value: 'monetize', label: 'Monetize' },
    ],
    phone_number: '',
    missions: '',
    church: '',
    links: '',
    self_introduction: '',
    monetize_choice: '',
    legal_accepted: false,
  }),
  validations: {
    phone_number: { required },
    missions: { required },
    church: { required },
    links: { required },
    self_introduction: { required },
    monetize_choice: { required },
    legal_accepted: {
      checked: val => val === true,
    },
  },
  methods: {
    validate() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      this.$emit('on-validate', this.$data, isValid);
      return isValid;
    },
  },
  components: { FormItem, Input, TextArea, TextError },
};
</script>



// WEBPACK FOOTER //
// src/components/FormArtistApplication.vue